var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.mini)?_c('img',{staticClass:"logo-mini-icon",attrs:{"src":require("@/assets/svg/unicall-logo-sign.svg"),"alt":"Logo"}}):_c('img',{attrs:{"src":require("@/assets/svg/unicall-logo.svg"),"alt":"Logo mini"}})}
var staticRenderFns = []

export { render, staticRenderFns }